import React from "react";
import { Link } from "react-router-dom";
import {
    Card,
    CardContent,
    Box,
    CardHeader,
    Typography,
    CardActionArea,
    Tooltip,
} from "@mui/material";
import { formatBytes } from "../../../../utilities/formatters";
import DoughnutChart from "../Charts/DoughnutChart";
import ResourceAvatar from "./ResourceAvatar";

const ResourcesCard = ({ data }) => {
    const [usedSpace, setUsedSpace] = React.useState(0);
    const [imageCount, setImageCount] = React.useState(0);
    const [documentCount, setDocumentCount] = React.useState(0);
    const [pdfCount, setPdfCount] = React.useState(0);
    const [totalCount, setTotalCount] = React.useState(0);

    React.useEffect(() => {
        let space = 0;
        let imgCount = 0;
        let docCount = 0;
        let pdfCnt = 0;
        let totalCnt = 0;

        if (data) {
            data.forEach((resource) => {
                space += resource.fileSize;
                totalCnt++;
                switch (resource.fileMimeType) {
                    case "image/jpeg":
                    case "image/png":
                        ++imgCount;
                        break;
                    case "application/pdf":
                        ++pdfCnt;
                        break;
                    case "text/csv":
                    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                        ++docCount;
                        break;
                    default:
                        break;
                }
            });
        }

        setUsedSpace(space);
        setImageCount(imgCount);
        setDocumentCount(docCount);
        setPdfCount(pdfCnt);
        setTotalCount(totalCnt);
    }, [data]);

    const dataSetLabel = "# of files";
    const dataSetLabels = ["Images", "PDF", "Documents"];
    const dataSetValues = [imageCount, pdfCount, documentCount];

    const usedSpaceFormatted = formatBytes(usedSpace);

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/portfolio/resources"}
                centerRipple={true}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View all resources" arrow>
                            <ResourceAvatar />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            Resources
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            Used space {usedSpaceFormatted}
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                {totalCount > 0 && (
                    <Box className="doughnut">
                        <DoughnutChart
                            label={dataSetLabel}
                            labels={dataSetLabels}
                            values={dataSetValues}
                        />
                    </Box>
                )}
                <Box className="card-content">
                    <Typography
                        variant="body1"
                        className="text"
                        sx={{ textAlign: "right" }}
                    >
                        {totalCount} files{" "}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ResourcesCard;
